'use client';
const IDENT_INPUT_ROOT = 'InputRoot';
const INPUT_STATES = {
    default: {},
    success: {
        color: 'primary'
    },
    error: {
        color: 'disruption'
    }
};
const defaultProps = {
    labelElement: 'label',
    size: 'md1',
    elementsOrder: [
        'label',
        'input',
        'hint'
    ],
    state: 'default',
    states: INPUT_STATES
};

export { IDENT_INPUT_ROOT, INPUT_STATES, defaultProps };
//# sourceMappingURL=InputRoot.contract.js.map
